"use client";

import HeaderButtons from "@/components/_partials/header/header-buttons";
import MobileDrawer from "@/components/_partials/header/mobile-drawer";
import NavLinks from "@/components/_partials/header/nav-links";
import TopAdComponent from "@/components/ads/top-ad-component";
import Authentication from "@/components/authentication/authentication";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";

const Header = ({ genres, categories }: { genres: any; categories: any }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [authenticationModal, setAuthenticationModal] = useState(false);
	const toggleDrawer = () => setIsOpen(!isOpen);

	return (
		<>
			<TopAdComponent />
			<nav className="backdrop-blur-lg text-white h-[68px] px-4 md:px-8 flex items-center justify-between z-30 sticky top-0 w-full">
				<Link href="/">
					<Image src={"/cutin.svg"} alt={"Cutin"} width={160} height={28} />
				</Link>
				<NavLinks genres={genres} categories={categories} />
				<HeaderButtons
					toggleDrawer={toggleDrawer}
					setAuthenticationModal={setAuthenticationModal}
				/>
			</nav>
			<MobileDrawer
				genres={genres}
				categories={categories}
				isOpen={isOpen}
				toggleDrawer={toggleDrawer}
			/>
			{authenticationModal && (
				<Authentication onClose={() => setAuthenticationModal(false)} />
			)}
		</>
	);
};

export default Header;
